import type { User } from '../../schemas/validation';

export type UserFilterOption = 'all' | 'admin' | 'user' | 'verified' | 'unverified';

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const filterUsers = (
  users: User[],
  searchTerm: string,
  filterRole: UserFilterOption
): User[] => {
  return users.filter(user => {
    const matchesSearch =
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter =
      filterRole === 'all' ||
      (filterRole === 'admin' && user.isAdmin) ||
      (filterRole === 'user' && !user.isAdmin) ||
      (filterRole === 'verified' && user.emailVerified) ||
      (filterRole === 'unverified' && !user.emailVerified);
    return matchesSearch && matchesFilter;
  });
};

export const getPaginatedUsers = (
  users: User[],
  currentPage: number,
  usersPerPage: number
): { currentUsers: User[]; startIndex: number; endIndex: number } => {
  const startIndex = (currentPage - 1) * usersPerPage;
  const endIndex = startIndex + usersPerPage;
  return {
    currentUsers: users.slice(startIndex, endIndex),
    startIndex,
    endIndex,
  };
};
